import {VoteButtonKeys, VoteButtonType} from "./interface"

export const voteButtonsDefault: Record<VoteButtonKeys, VoteButtonType> = {
    accept: {
        key: "accept",
        icon: "check",
        colorScheme: "green",
        text: "Yes"
    },
    reject: {
        key: "reject",
        icon: "times",
        colorScheme: "red",
        text: "No"
    },
    unsure: {
        key: "unsure",
        icon: "question-circle",
        colorScheme: "yellow",
        text: "Unsure"
    },
    skip: {
        key: "skip",
        icon: "arrow-circle-right",
        colorScheme: "gray",
        text: "Not Applicable"
    }
}